import React from 'react';
import { ChatbotDataProvider } from './ChatbotDataProvider';
import { ChatMessagesProvider } from './ChatMessagesProvider';
import { LoadingStateProvider } from './LoadingStateProvider';
import { ChatUIContextProvider } from './ChatUIContextProvider';
import { RealTimeProvider } from './RealTimeProvider';
/**
 * ChatProvider is a utility component that consolidates multiple context providers
 * into a single wrapper for chat-related state management.
 *
 * It combines:
 * - ChatbotDataProvider: Core chatbot configuration and data
 * - ChatMessagesProvider: Message history and updates
 * - LoadingStateProvider: Loading states across the chat interface
 * - ChatUIContextProvider: UI-related state management
 * - RealTimeProvider: Real-time chat functionality state
 *
 * @example
 * ```tsx
 * <ChatProvider
 *   chatbotData={chatbotDataValue}
 *   chatMessages={messagesValue}
 *   loadingState={loadingValue}
 *   ui={uiValue}
 *   realtime={realtimeValue}
 * >
 *   <ChatInterface />
 * </ChatProvider>
 * ```
 * @public
 */
export const ChatProvider = ({
  children,
  chatbotData,
  chatMessages,
  loadingState,
  ui,
  realtime
}) => {
  return React.createElement(ChatbotDataProvider, Object.assign({}, chatbotData), React.createElement(ChatMessagesProvider, {
    value: chatMessages
  }, React.createElement(LoadingStateProvider, {
    value: loadingState
  }, React.createElement(ChatUIContextProvider, {
    value: ui
  }, React.createElement(RealTimeProvider, {
    value: realtime
  }, children)))));
};